export default {
  login: {
    title: 'QuBit Affiliate',
    subtitle: '欢迎注册 QuBit Affiliate',
    accountLogin: '账号登录',
    mobileLogin: '手机登录',
    qrCodeLogin: '二维码登录',
    register: '注册',
    scanQRCodeTip: '请使用手机扫描二维码登录',
    backToLogin: '返回登录',
    mobilePlaceholder: '手机号',
    qrCodePlaceholder: '二维码',
    smsPlaceholder: '短信验证码',
    verificationCodePlaceholder: '验证码',
    mobileRequired: '请输入手机号',
    qrCodeRequired: '请扫描二维码',
    smsRequired: '请输入短信验证码',
    sendCode: '发送验证码',
    scanQrcode: '扫描二维码',
    // qrCodeLogin: '二维码登录',
    usernamePlaceholder: '用户名/电子邮件',
    passwordPlaceholder: '请输入密码',
    captchaPlaceholder: '请输入验证码',
    usernameRequired: '请输入用户名/手机号',
    passwordRequired: '请输入密码',
    captchaRequired: '请输入验证码',
    captchaMismatch: '错误的验证代码',
    captchaError: '验证码错误',
    rememberMe: '7天内免登录',
    forgotPassword: '忘记密码？',
    loginButton: '登录',
    loginSuccess: '登录成功！',
    loginFailed: '登录失败，请检查用户名和密码！',
    emailSent: '验证码已发送',
    processingToken: '登录中...',
  },
  common: {
    theme: {
      light: '浅色模式',
      dark: '深色模式'
    },
    language: {
      zh: '简体中文',
      en: 'English',
      zhTW: '繁体中文'
    },
    actions: {
      expand: '展开',
      collapse: '收起',
      view: '查看',
      edit: '编辑',
      delete: '删除',
      create: '创建',
      save: '保存',
      cancel: '取消',
      confirm: '确认',
      reset: '重置',
      search: '搜索',
      export: '导出',
      import: '导入'
    },
    notification: '通知',
    search: '搜索',
    fullscreen: '全屏显示',
    exitFullscreen: '退出全屏',
    languageSwitch: '切换语言',
    settings: '系统设置',
    yes: '确定',
    no: '取消',
    edit:'编辑',
    delete:'删除',
    create: '创造',
    cancel: '取消',
    save: '保存',
    export: '导出',
    unknown: '未知',
    and: '和',
    validation: {
      walletAddressError: '请输入数字ID。',
      numericOnlyError: '该字段只能包含数字。'
    }
  },
  messages: {
    error: {
      networkError: '网络错误，请稍后重试',
      serverError: '服务器错误，请稍后重试'
    }
  },
  register: {
    subtitle: '欢迎注册 QuBit Affiliate',
    usernamePlaceholder: '请输入用户名',
    mobilePlaceholder: '请输入手机号',
    smsPlaceholder: '请输入短信验证码',
    emailPlaceholder: '电子邮件',
    emailCodePlaceholder: '验证码',
    invalidEmail: '无效邮箱',
    passwordPlaceholder: '请输入密码',
    confirmPasswordPlaceholder: '请确认密码',
    usernameRequired: '请输入用户名',
    mobileRequired: '请输入手机号',
    smsRequired: '请输入短信验证码',
    emailRequired: '请输入您的电子邮件',
    codeRequired: '请输入验证码',
    passwordRequired: '请输入密码',
    confirmPasswordRequired: '请确认密码',
    passwordMinLength: '密码长度不能小于6位',
    passwordNotMatch: '两次输入的密码不一致',
    agreement: '我已阅读并同意',
    agreementLink: '《用户协议》',
    termLink: '《使用条款》',
    privacyLink: '《隐私政策》',
    agreementRequired: '请阅读并同意用户协议。',
    cookiesPolicy: '本网站使用cookies以确保最佳用户体验。这些cookies是严格必要的或对最佳功能至关重要的。使用本网站即表示您同意cookies政策。',
    sendCode: '发送验证码',
    smsSent: '验证码已发送',
    smsFailed: '验证码发送失败',
    emailSent: '验证码已发送',
    emailFailed: '发送验证码失败',
    submit: '注册',
    success: '注册成功',
    failed: '注册失败',
    backToLogin: '返回登录',
    inviteCodePlaceholder: "输入邀请码",
    inviteCodeRequired: "需要邀请码",
    inviteCodeMaxLength: "邀请代码必须少于6个字符。",
    passwordRules: {
      minLength: '密码长度不能少于8位',
      maxLength: '密码长度不能超过20位',
      requireNumber: '密码必须包含数字',
      requireLower: '密码必须包含小写字母',
      requireUpper: '密码必须包含大写字母',
      requireSpecial: '密码必须包含特殊字符'
    },
    passwordStrength: {
      veryWeak: '极弱',
      weak: '弱',
      medium: '中等',
      strong: '强',
      veryStrong: '极强'
    },
    passwordRequirements: {
      title: '密码要求',
      length: '长度在8-20个字符之间',
      number: '必须包含数字',
      upper: '必须包含大写字母',
      lower: '必须包含小写字母',
      special: '必须包含特殊字符'
    }
  },
  reset: {
    subtitle: '重置您的密码',
    mobilePlaceholder: '请输入手机号',
    smsPlaceholder: '请输入短信验证码',
    newPasswordPlaceholder: '请输入新密码',
    confirmPasswordPlaceholder: '请确认新密码',
    mobileRequired: '请输入手机号',
    smsRequired: '请输入短信验证码',
    newPasswordRequired: '请输入新密码',
    confirmPasswordRequired: '请确认新密码',
    passwordMinLength: '密码长度不能小于6位',
    passwordNotMatch: '两次输入的密码不一致',
    sendCode: '发送验证码',
    smsSent: '验证码已发送',
    smsFailed: '验证码发送失败',
    submit: '重置密码',
    success: '密码重置成功',
    failed: '密码重置失败',
    backToLogin: '返回登录'
  },
  profile: {
    basicInfo: '基本信息',
    security: '安全设置',
    activity: '账号动态',
    notification: '通知设置',
    apiAccess: 'API 访问',
    username: '用户名',
    email: '邮箱',
    mobile: '手机号',
    gender: '性别',
    genderOptions: {
      male: '男',
      female: '女',
      other: '其他'
    },
    birthday: '生日',
    location: '所在地',
    bio: '个人简介',
    company: '公司',
    position: '职位',
    website: '个人网站',
    uploadAvatar: '上传头像',
    cropAvatar: '裁剪头像',
    avatarTypeError: '只能上传 JPG/PNG 格式的图片',
    avatarSizeError: '图片大小不能超过 2MB',
    avatarUpdateSuccess: '头像更新成功',
    avatarUpdateFailed: '头像更新失败',
    save: '保存',
    validation: {
      usernameRequired: '请输入用户名',
      usernameFormat: '用户名只能包含字母、数字、下划线，长度3-20位',
      emailRequired: '请输入邮箱',
      emailFormat: '请输入正确的邮箱格式',
      mobileRequired: '请输入手机号',
      mobileFormat: '请输入正确的手机号格式',
      bioMaxLength: '个人简介不能超过200字',
      websiteFormat: '请输入正确的网址格式'
    },
    oldPassword: '原密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    changePassword: '修改密码',
    updateSuccess: '更新成功',
    updateFailed: '更新失败',
    passwordChanged: '密码修改成功',
    passwordChangeFailed: '密码修改失败',
    invalidMobile: '请输入正确的手机号',
    twoFactor: '两步验证',
    loginDevices: '登录设备',
    notificationSettings: '通知设置',
    loginHistory: '登录历史',
    operationLog: '操作记录',
    apiTokens: 'API 令牌',
    webhooks: 'Webhook 设置',
    loginDays: '登录天数',
    lastActive: '最近活跃',
    deviceInfo: {
      browser: '浏览器',
      os: '操作系统',
      ip: 'IP 地址',
      location: '登录地点',
      time: '登录时间',
      current: '当前设备',
      lastActive: '最后活跃',
      revokeAccess: '撤销访问',
      revokeConfirm: '确定要撤销此设备的访问权限吗？'
    },
    notificationTypes: {
      all: '所有通知',
      system: '系统通知',
      security: '安全通知',
      activity: '活动通知'
    },
    apiTokenSettings: {
      create: '创建令牌',
      name: '令牌名称',
      token: '令牌',
      permissions: '权限',
      expiresAt: '过期时间',
      lastUsed: '最后使用',
      created: '创建时间',
      status: '状态',
      active: '生效中',
      expired: '已过期',
      revoked: '已撤销'
    },
    webhookSettings: {
      create: '创建 Webhook',
      url: '回调 URL',
      secret: '密钥',
      events: '事件类型',
      status: '状态',
      lastDelivery: '最后推送',
      deliveryStatus: '推送状态'
    }
  },
  user: {
    profile: '个人信息',
    logout: '退出登录',
    defaultName: '用户',
    actions: {
      notification: {
        title: '通知中心',
        unread: '{count} 条未读消息'
      },
      search: {
        title: '全局搜索',
        placeholder: '搜索...'
      },
      settings: {
        title: '系统设置',
        theme: '主题设置',
        language: '语言设置',
        other: '其他设置'
      }
    }
  },
  route: {
    home: '首页',

    dataAnalysis: '数据分析',
    'dataAnalysis.dataOverview': '数据概览',
    'dataAnalysis.dailyDataAnalysis': '每日数据分析',

    customerManagement: '客户管理',
    'customerManagement.clientList': '客户列表',
    'customerManagement.clientGrouping': '客户分组',
    'customerManagement.superAgentSystem': '超级代理商体系',
    'customerManagement.operationRecord': '操作记录',

    invitationPromotion: '邀请推广',
    'invitationPromotion.invitationLink': '邀请链接',
    'invitationPromotion.customRegistrationPage': '自定义注册页',
    'invitationPromotion.invitationReviewRecord': '操作记录',

    financialDetails: '财务明细',
    'financialDetails.commission': '佣金明细',
    'financialDetails.transaction': '交易明细',
    'financialDetails.daily': '每日数据汇总',

    supportCenter: '支持中心',
    'supportCenter.materialLibrary': '素材库管理',
    'supportCenter.helpCenter': '帮助中心',

    activityCenter: '活动中心',

    overview: '概览',

    // 系统管理
    system: '系统管理',
    'system.user': '用户管理',
    'system.role': '角色管理',
    'system.menu': '菜单管理',
    'system.dept': '部门管理',
    
    // 网络请求
    network: '网络请求',
    'network.basic': '基础网络',
    'network.advanced': '高级网络',
    
    // 个人页面
    profile: '个人页',
    'profile.basic': '基础详情页',
    'profile.advanced': '高级详情页',
    
    // 错误页面
    error: '错误页',
    'error.403': '403',
    'error.404': '404',
    'error.500': '500',
    // 认证页面
    auth: '认证页',
    'auth.login': '登录',
    'auth.register': '注册',
    'dataChart': '数据图表',
    'chart': '数据表格', // 添加这一行
  },
  network:{
    'network-error': '网络错误，请检查网络连接',
    'bad-request': '400 请求参数错误',
    'unauthorized': '401 账号密码错误，请重新登录',
    'forbidden': '403 拒绝访问',
    'not-found': '404 请求错误，未找到该资源',
    'internal-error': '500 服务器错误',
    'request-canceled-or-timeout': '请求已取消或超时'
  },
  apiError: {
    '1001': '系统繁忙',
    '1002': '服务暂时不可用',
    '1003': '请求参数错误',
    '1004': '签名验证失败',
    '1005': '请求时间异常',
    '1006': '无效操作,请刷新页面重试',
    '1007': '未找到数据',
    '1008': '数据库出错',
    '1009': '验证码错误',
    '1010': '验证码失效,请重新获取',
    '1011': '图形验证码错误',
    '1012': '请求频繁',
    '1013': '操作超时,请重试',
    '1014': '时间区间不支持,最大支持七天',
    '1015': '最多导出3周数据',
    '1101': '禁止登录',
    '1102': '用户名或密码不正确',
    '1103': '当前用户仅限密码登录',
    '1104': '需要绑定谷歌验证器',
    '1105': '无效的验证器验证码',
    '1106': '用户不存在',
    '1107': '需要进行两步验证',
    '1108': '暂无权限，请修改密码后访问。',
    '1109': '无权访问',
    '1110': '用户状态错误',
    '1111': '目标用户是被操作用户下级,无法进行移动',
    '1112': '其他用户正在进行用户移动或代理添加操作,请稍后再试',
    '1113': '该ID无效或用户ID不是下属',
    '1114': '返佣比例超出限制',
    '1115': '登录过期',
    '1116': '正在进行返佣清算,请稍后再试',
    '1117': '请求参数重复',
    '1118': '无法降低返利比例',
    '1119': '无效的Token',
    '1120': '返佣比例不能低于或等于普通用户比例',
  },
  overview: {
    title: '数据概览',
    dataUpdatedAt: '数据更新于：{time}（UTC+8 时区）',
    overview: '数据概览',
    totalCommission: '总佣金(USDT)',
    totalCommissionTooltip: '总佣金',
    time: '时间',
    month: '月份',
    customer: '客户数量',
    selfRebate: '自返佣',
    netFee: '净手续费',
    totalVolume: '总交易量(USDT)', 
    totalVolumeNote: '*该数值为代理下所有用户，包含直接用户与间接用户',
    customerCount: '客户数(人)',
    customerCountNote: '*该数值为代理下所有用户，包含直接用户与间接用户',
    comparison: '环比',
    hello: '您好,{name}',
    spot: '现货',
    futures: '合约',
    alpha: 'Alpha',
    pendingWithdraw: '待提取',
    withdraw: '提现',
    claim: '认领',
    customerActivity: '客户活跃度',
    customerActivityNote: '*该数值为代理下所有用户，包含直接用户与间接用户',
    activeUsers: '每日活跃人数',
    inactiveUsers: '非活跃人数',
    myReferralLinks: '我的推广链接',
    inviteCode: '邀请码',
    inviteeCount: '邀请人数',
    spotRebateRate: '现货返佣比例',
    futuresRebateRate: '合约返佣比例',
    alphaRebateRate: 'Alpha 返佣比例',
    operation: '操作',
    myCommission: '我的',
    customerCommission: '客户',
    defaultLink: '默认链接',
    shareLink: '分享链接',
    recentRegistrations: '最近注册',
    recentRegistrationsNote: '该数据仅包含直接推荐用户',
    userUID: '用户UID',
    registrationTime: '注册时间',
    isDeposited: '是否已入金',
    isActive: '是否活跃',
    yes: '是',
    no: '否',
    notifications: {
      userReward: '用户***{id}***获得{amount}USDT奖金'
    },
    noInviteCode: '暂无邀请码',
    noRecentRegistrations: '暂无最近注册数据',
    errorLoadingData: '加载数据时出错：',
    claimError: '认领佣金时出错',
    loadingOverviewData: '加载概览数据中...',
    loadingRecentRegistrations: '加载最近注册数据中...',
    codeCopied: '邀请码已复制到剪贴板',
    linkCopied: '推荐链接已复制到剪贴板',
  },
  dataAnalysis: {
    dataOverview: {
      title: '返佣明细',
      dataUpdatedAt: '数据更新于：{time}（UTC+8 时区）',
      productLine: '产品线',
      subAgentUID: '子代理UID',
      pleaseEnterPlaceholder: '请输入',
      invitationCode: '邀请码',
      transactionTime: '交易时间',
      startTime: '开始时间',
      endTime: '结束时间',
      export: '导出',
      reset: '重置',
      query: '查询',
      all: '全部',
      futures: '合约交易',
      spot: '现货交易',
      none: '无',
      of: '共',
      items: '项',
      table: {
        subAgentContributionRanking: '子代理贡献排名',
        invitationCodeContributionRanking: '邀请码贡献排名',
        rank: '排名',
        subAgentUID: '子代理UID',
        contributionCommission: '贡献佣金 (USDT)',
        transactionAmount: '交易金额 (USDT)',
        invitationCode: '邀请码',
        registrationsCount: '注册人数'
      },
      line: {
        title: '数据趋势分析',
        commission: '佣金',
        totalTransactionVolume: '总交易量',
        numberOfInvitees: '邀请人数',
        numberOfDeposits: '入金人数',
        newUserTrend: '新增用户趋势',
        commissionTrend: '佣金趋势'
      }
    },
    dailyDataAnalysis: {
      title: '每日数据分析',
      productLine: '产品线',
      transactionTime: '交易时间',
      startTime: '开始时间',
      endTime: '结束时间',
      reset: '重置',
      query: '查询',
      all: '全部',
      futures: '合约交易',
      spot: '现货交易',
      of: '共',
      items: '项',
      none: '无',
      table: {
        date: '日期',
        newUsers: '新增用户',
        activeUsers: '活跃用户',
        totalDeposits: '总入金',
        totalTradingVolume: '总交易量',
        totalFees: '总手续费',
        totalCommission: '总佣金'
      }
    }
  },
  customerManagement: {
    clientList: {
      title: '客户列表',
      dataUpdatedAt: '数据更新于：{time}（UTC+8 时区）',
      customerDetails: '客户详情',
      customerUID: '客户UID',
      customerEmail: '电子邮件 / 钱包地址',
      pleaseEnterPlaceholder: '请输入',
      customerGroup: '客户分组',
      customerType: '客户类型',
      transactionTime: '交易时间',
      startTime: '开始时间',
      endTime: '结束时间',
      reset: '重置',
      query: '查询',
      all: '全部',
      superiorAgent: '上级超级代理商',
      clientListTable: '客户列表',
      totalRecords: '条记录',
      selected: '已选择',
      of: '共',
      items: '项',
      none: '无',
      direct: '直接',
      indirect: '间接',
      copySuccess: '复制成功。',
      copyError: '复制错误。',
      fetchError: '获取数据时发生错误。',
      groupFetchError: '获取分组列表时发生错误。',
      modifyDirectOnly: '您只能修改直接客户的客户比例。',
      modifyRatioIncreaseOnly: '您只能增加比例。',
      modifySuccess: '保存成功。',
      modifyError: '修改时出错。',
      addAgentError: '添加代理时出错。',
      manageError: '管理客户时出错。',
      remarkError: '编辑备注时出错。',
      detailsError: '获取详情时出错。',
      historyError: '获取历史时出错。',
      entrustType: {
        market: '市价单',
        limit: '计划单',
        liquidation: '强平单'
      },
      orderType: {
        marketOrder: '市价单',
        planOrder: '计划单',
        takeProfitOrder: '止盈单',
        stopLossOrder: '止损单',
        forcedLiquidationOrder: '强平单'
      },
      direction: {
        buy: '买入',
        sell: '卖出'
      },
      role: {
        maker: '挂单方',
        taker: '吃单方'
      },
      status: {
        default: '默认',
        userRevocation: '用户撤销',
        marketUnfilledRevocation: '市价未成交撤销',
        backgroundRevocation: '后台撤销',
        full: '全部成交',
        partialRetracted: '部分成交已撤',
        partialSlot: '部分成交'
      },
      table: {
        uid: 'UID',
        label: '备注',
        registrationTime: '注册时间',
        customerType: '客户类型',
        superiorAgentUID: '上级代理UID',
        username: '用户名',
        tradingVolume: '交易量 (USDT)',
        handlingFee: '手续费 (USDT)',
        commissions: '佣金 (USDT)',
        deposit: '入金 (USDT)',
        associatedGroup: '关联分组',
        assetRange: '资产范围 (USDT)',
        firstDepositTime: '首次入金时间',
        firstLastTransactionTime: '首次/最后交易时间',
        firstTransactionTime: '首次交易时间',
        lastTransactionTime: '最后交易时间',
        operation: '操作',
        view: '查看',
        manage: '管理',
        history: '历史委托',
        futures: '合约',
        spot: '现货',
        transactionUID: '交易 UID',
        transactionMethod: '交易方式',
        tradingPair: '交易对',
        direction: '方向',
        subjectiveMethod: '主观方式',
        averageTransactionPrice: '成交均价',
        executedOrderedVolume: '已成交/委托量',
        transactionFee: '手续费',
        orderStatus: '订单状态',
        creationTime: '创建时间',
        addAgent: '添加代理',
        remark: '备注',
        active: '活跃',
        inactive: '非活跃',
        registrationTimeTooltip: '活跃：最近7天内有交易。非活跃：最近7天内无交易。'
      },
      manage: {
        title: '管理客户',
        clientUID: '客户UID',
        clientLabel: '客户标注',
        clientLabelPlaceholder: '请输入标注',
        commissionSettings: '设定返佣比例',
        spot: '现货',
        futures: '合约',
        clientRatio: '客户的比例',
        myRatio: '我的的比例',
        modifyNote: '注意：初始佣金比例的更改将使该客户成为您的代理。',
        cancel: '取消',
        confirm: '确定'
      },
      addAgent: {
        title: '添加为代理',
        commissionSettings: '设定返佣比例',
        confirm: '添加为代理'
      },
      remark: {
        title: '编辑备注',
        label: '备注',
        placeholder: '请输入备注',
        confirm: '保存备注'
      },
      details: {
        title: '基本信息',
        spot: '现货返佣比例',
        futures: '合约返佣比例',
        alpha: 'Alpha返佣比例',
        customerType: '客户类型',
        directClient: '直接客户',
        indirectClient: '间接客户',
        superiorAgentUID: '上级代理UID',
        group: '分组名称',
        none: '无',
        registrationTime: '注册时间'
      }
    },
    clientGroup: {
      title: '客户分组',
      dataUpdatedAt: '数据更新于：{time}（UTC+8 时区）',
      groupName: '分组名称',
      pleaseEnterGroupNamePlaceholder: '请输入分组名称',
      creationTime: '创建时间',
      queryTime: '查询时间',
      startTime: '开始时间',
      endTime: '结束时间',
      totalRecords: '条记录',
      selected: '已选择',
      of: '共',
      items: '项',
      none: '无',
      copySuccess: '复制成功。',
      copyError: '复制错误。',
      fetchError: '获取数据时发生错误。',
      groupFetchError: '获取分组列表时发生错误。',
      modifyDirectOnly: '您只能修改直接客户的客户比例。',
      modifyRatioIncreaseOnly: '您只能增加比例。',
      createSuccess: '创建成功。',
      createError: '创建时出错。',
      modifySuccess: '保存成功。',
      modifyError: '修改时出错。',
      table: {
        dataList: '数据列表',
        addGroup: '添加分组',
        groupId: '分组ID',
        groupName: '分组名称',
        creationTime: '创建时间',
        memberCount: '分组人数',
        spotRatio: '现货返佣比例',
        futuresRatio: '合约返佣比例',
        depositorCount: '入金人数',
        totalDeposit: '累计入金(USDT)',
        totalVolume: '累计交易量(USDT)',
        totalCommission: '累计返佣(USDT)',
        operation: '操作',
        manage: '管理',
      },
      create: {
        addTitle: '添加新分组',
        manageTitle: '管理分组',
        groupName: '分组名称',
        groupNameMaxLength: '最多12个字符',
        commissionSettings: '设定返佣比例',
        spot: '现货',
        futures: '合约',
        alpha: 'Alpha',
        clientRatio: '客户的比例',
        myRatio: '我的的比例',
        newUser: '新用户',
        selected: '已选择',
        people: '人',
        notAvailable: '不可用',
        pleaseEnterCustomerUID: '请输入客户UID',
        noMember: '未选择任何成员',
        cancel: '取消',
        confirm: '确认'
      }
    },
    superAgent: {
      title: '超级代理系统',
      dataUpdatedAt: '数据更新于：{time}（UTC+8 时区）',
      superAgentUID: '超级代理UID',
      pleaseEnterPlaceholder: '请输入',
      customerGroup: '客户分组',
      transactionTime: '交易时间',
      startTime: '开始时间',
      endTime: '结束时间',
      reset: '重置',
      query: '查询',
      all: '全部',
      none: '无',
      of: '共',
      items: '项',
      copySuccess: '复制成功。',
      copyError: '复制错误。',
      fetchError: '获取数据时发生错误。',
      groupFetchError: '获取分组列表时发生错误。',
      modifyDirectOnly: '您只能修改直接客户的客户比例。',
      modifyRatioIncreaseOnly: '您只能增加比例。',
      createSuccess: '创建成功。',
      createError: '创建时出错。',
      modifySuccess: '保存成功。',
      modifyError: '修改时出错。',
      table: {
        superAgentUID: '超级代理UID',
        timeToBecomeSuperAgent: '入驻时间', // 'Time to Become a Super Agent',
        invitationCode: '邀请码',
        registrationTime: '注册时间',
        totalInvites: '总邀请人数',
        agentCount: '代理人数',
        rebateRatio: '返佣比例',
        operation: '操作',
        manage: '管理'
      },
      manage: {
        addTitle: '添加超级代理',
        manageTitle: '修改超级代理',
        UID: 'UID',
        username: '用户名',
        usernamePlaceholder: '设置用户名或备注',
        commissionSettings: '设置佣金比例',
        spot: '现货',
        futures: '合约',
        alpha: 'Alpha',
        clientRatio: '客户的比例',
        myRatio: '我的的比例',
        cancel: '取消',
        confirm: '确认'
      }
    }
  },
  invitationPromotion: {
    invitationLink: {
      title: '邀请链接',
      dataUpdatedAt: '数据更新时间：{time}（UTC+8时区）',
      searchQuery: '搜索查询',
      code: '邀请码',
      pleaseEnterPlaceholder: '请输入邀请码或备注',
      promotionChannel: '推广渠道',
      all: '全部',
      dataStatisticsTime: '数据统计时间',
      startTime: '开始时间',
      endTime: '结束时间',
      reset: '重置',
      query: '查询',
      totalRecords: '条记录',
      selected: '已选择',
      of: '共',
      items: '项',
      none: '无',
      copySuccess: '复制成功。',
      copyError: '复制错误。',
      fetchError: '获取数据时发生错误。',
      groupFetchError: '获取分组列表时发生错误。',
      modifyDirectOnly: '您只能修改直接客户的客户比例。',
      modifyRatioIncreaseOnly: '您只能增加比例。',
      modifySuccess: '保存成功。',
      modifyError: '修改时出错。',
      
      table: {
        code: '邀请码',
        default: '默认链接',
        custom: '自定义注册页',
        spot: '现货返佣比例',
        futures: '合约返佣比例',
        alpha: 'Alpha返佣比例',
        linkLocation: '链接定位',
        clickCount: '点击数',
        registrationCount: '注册人数',
        depositCount: '入金人数',
        tradeCount: '交易人数',
        tradingVolume: '交易量(USDT)',
        rebateAmount: '返佣金额(USDT)',
        operation: '操作',
        settings: '设置',
        shareLink: '分享链接',
      },
      share: {
        title: '邀请好友',
        yourCode: '您的邀请码是',
        whatsapp: 'WhatsApp',
        line: 'LINE',
        telegram: 'Telegram',
        twitter: 'Twitter',
        facebook: 'Facebook',
        shareMessage: '邀请好友加入QuBit，赚取奖励',
        copySuccess: '链接已复制到剪贴板',
        copySuccessMsg: '链接已复制到剪贴板',
        copyFailed: '复制链接失败',
        copyFailedMsg: '复制链接失败，请手动复制',
        bindSuccess: '绑定成功',
        bindFailed: '绑定邀请码失败',
        requestFailed: '请求失败',
        shareTitle: '分享邀请链接'
      },
      settings: {
        title: '链接详情',
        invitationLink: '邀请链接',
        spot: '现货',
        futures: '合约',
        alpha: 'Alpha',
        web3: 'Web3',
        link: '邀请链接',
        code: '邀请码',
        registrationType: '注册页类型',
        remarks: '备注',
        remarksPlaceholder: '请输入备注',
        dataOverview: '数据概览',
        rebateAmount: '返佣金额(USDT)',
        tradingVolume: '交易量(USDT)',
        numberOfClicks: '点击数',
        numberOfInvites: '邀请人数',
        numberOfTraders: '交易人数',
        numberOfDepositors: '入金人数',
        modifyRebateRatio: '修改返佣比例',
        changeInvitationCode: '更换邀请码',
        editRegistrationType: '编辑注册页类型',
        customRegistrationPage: '自定义注册页',
        notSelected: '未选择',
        cancel: '取消',
        confirm: '确认'
      }
    },
    registration: {
      title: '自定义注册页',
      create: '创建注册页',
      edit: '编辑注册页',
      totalRecords: '条记录',
      selected: '已选择',
      of: '共',
      items: '项',
      copySuccess: '复制成功。',
      copyError: '复制错误。',
      fetchError: '获取数据时发生错误。',
      groupFetchError: '获取分组列表时发生错误。',
      modifyDirectOnly: '您只能修改直接客户的客户比例。',
      modifyRatioIncreaseOnly: '您只能增加比例。',
      modifySuccess: '保存成功。',
      modifyError: '修改时出错。',
      table: {
        name: '注册页名称',
        validity: '页面有效时间',
        to: '至',
        creationTime: '页面创建时间',
        linkCount: '邀请链接数',
        profileInfo: '个人信息',
        status: '状态',
        default: '默认注册页',
        operation: '操作',
        edit: '编辑',
        yes: '是',
        no: '否'
      },
      custom: {
        title: '创建注册页',
        name: '注册页名称',
        registrationPageNamePlaceholder: '请输入注册页名称',
        showPersonalInfo: '显示个人信息',
        hidePersonalInfo: '隐藏个人信息',
        upload: '上传',
        namePlaceholder: '请输入姓名',
        introduction: '简介',
        introductionPlaceholder: '请输入不超过100个汉字或200个英文字符。',
        recommendedImageMaterials: '推荐图片素材',
        default: '默认',
        noImage: '无图片',
        platformStrength: '平台实力',
        transactionRebate: '交易返佣',
        manyBenefits: '多重福利',
        thoughtfulService: '贴心服务',
        eventImage: '活动图片',
        recommendedSize: '（推荐：560 * 300）',
        // upload
        validity: '页面有效期（二选一）',
        longTermEffective: '长期有效',
        customTime: '自定义时间',
        start: '开始时间',
        end: '结束时间',
        eventLink: '活动链接',
        eventLinkPlaceholder: '请输入',
        cancel: '取消',
        create: '创建',
        confirm: '确认'
      }
    },
    review: {
      title: '操作记录',
      dataUpdatedAt: '数据更新时间：{time}（UTC+8时区）',
      customerUID: '客户UID',
      pleaseEnterPlaceholder: '请输入客户UID',
      type: '类型',
      invitationLink: '邀请链接',
      reset: '重置',
      query: '查询',
      add: '添加代理',
      modify: '修改代理',
      groupUpsert: '分组更新',
      groupMemberUpsert: '分组成员更新',
      topAgentAdd: '添加顶级代理',
      all: '全部',
      totalRecords: '条记录',
      selected: '已选择',
      of: '共',
      items: '项',
      none: '无',
      copySuccess: '复制成功。',
      copyError: '复制错误。',
      fetchError: '获取数据时发生错误。',
      groupFetchError: '获取分组列表时发生错误。',
      modifyDirectOnly: '您只能修改直接客户的客户比例。',
      modifyRatioIncreaseOnly: '您只能增加比例。',
      modifySuccess: '保存成功。',
      modifyError: '修改时出错。',
      table: {
        submissionTime: '提交时间',
        customerUID: '客户UID',
        type: '类型',
        spot: '现货返佣比例',
        futures: '合约返佣比例',
        alpha: 'Alpha返佣比例',
        confirmationTime: '确认时间',
        status: '状态',
        reason: '失败原因',
        operation: '操作',
        viewDetails: '查看详情'
      }
    }
  },
  financialDetails: {
    commission: {
      title: '佣金明细',
      dataUpdatedAt: '数据更新时间：{time}（UTC+8时区）',
      customerUID: '客户UID',
      customerPlaceholder: '请输入客户UID',
      orderID: '订单ID',
      orderIDPlaceholder: '请输入订单ID',
      rebateType: '返佣类型',
      all: '全部',
      transactionTime: '交易时间',
      startTime: '开始时间',
      endTime: '结束时间',
      tradingPair: '交易对',
      transactionMethod: '交易方式',
      buy: '买入',
      sell: '卖出',
      reset: '重置',
      query: '查询',
      none: '无',
      cumulativeCommission: '累计返佣',
      spot: '现货',
      futures: '合约',
      alpha: 'Alpha',
      of: '共',
      items: '项',
      copySuccess: '复制成功。',
      copyError: '复制错误。',
      fetchError: '获取数据时发生错误。',
      groupFetchError: '获取分组列表时发生错误。',
      modifyDirectOnly: '您只能修改直接客户的客户比例。',
      modifyRatioIncreaseOnly: '您只能增加比例。',
      modifySuccess: '保存成功。',
      modifyError: '修改时出错。',
      exportSuccess: '数据导出成功！',
      noDataToExport: '没有可导出的数据。',
      exportError: '导出失败。请再试一次。',
      table: {
        customerUID: '客户UID',
        remark: '备注',
        orderID: '订单ID',
        customerGroup: '客户分组',
        associatedAgent: '关联代理',
        superiorAgentUID: '上级代理UID',
        tradingPair: '交易对',
        rebateRate: '返佣比例',
        rebateAmount: '返佣金额',
        rebateTime: '返佣时间',
        transactionMethod: '交易方式',
        depositStatus: '入账状态',
      },
      depositStatusOptions: {
        unsettled: '未结算',
        pending: '待发放',
        completed: '已发放',
        cancelled: '已取消',
        frozen: '冻结发放'
      },
      rebateOptions: {
        spot: '现货',
        futures: '合约',
        alpha: 'Alpha'
      }
    },
    transaction: {
      title: '交易明细',
      dataUpdatedAt: '数据更新时间：{time}（UTC+8时区）',
      customerUID: '客户UID',
      customerPlaceholder: '请输入客户UID',
      superiorAgentUID: '上级代理UID',
      superiorAgentPlaceholder: '请输入上级代理UID',
      tradingPair: '交易对',
      all: '全部',
      groupName: '分组名称',
      default: '默认',
      role: '角色',
      maker: 'Maker',
      taker: 'Taker',
      transactionTime: '交易时间',
      startTime: '开始时间',
      endTime: '结束时间',
      transactionMethod: '交易方式',
      buy: '买入',
      sell: '卖出',
      reset: '重置',
      query: '查询',
      none: '无',
      cumulativeTradingVolume: '累计交易量（USDT）',
      cumulativeTransactionFees: '累计手续费（USDT）',
      spot: '现货',
      futures: '合约',
      alpha: 'Alpha',
      of: '共',
      items: '项',
      copySuccess: '复制成功。',
      copyError: '复制错误。',
      fetchError: '获取数据时发生错误。',
      groupFetchError: '获取分组列表时发生错误。',
      modifyDirectOnly: '您只能修改直接客户的客户比例。',
      modifyRatioIncreaseOnly: '您只能增加比例。',
      modifySuccess: '保存成功。',
      modifyError: '修改时出错。',
      exportSuccess: '数据导出成功！',
      noDataToExport: '没有可导出的数据。',
      exportError: '导出失败。请再试一次。',
      table: {
        customerUID: '客户UID',
        remark: '备注',
        orderID: '订单ID',
        email: '邮箱',
        handlingFee: '手续费',
        group: '分组',
        superiorAgentUID: '上级代理UID',
        transactionTime: '交易时间',
        tradingPair: '交易对',
        transactionVolume: '交易量',
        netFee: '净手续费',
        transactionMethod: '交易方式',
        operationAmount: '操作金额'
      }
    },
    daily: {
      title: '每日数据汇总',
      dataUpdatedAt: '数据更新时间：{time}（UTC+8时区） *T+1后更新数据',
      timeRange: '时间范围',
      startTime: '开始时间',
      endTime: '结束时间',
      none: '无',
      of: '共',
      items: '项',
      copySuccess: '复制成功。',
      copyError: '复制错误。',
      fetchError: '获取数据时发生错误。',
      groupFetchError: '获取分组列表时发生错误。',
      modifyDirectOnly: '您只能修改直接客户的客户比例。',
      modifyRatioIncreaseOnly: '您只能增加比例。',
      modifySuccess: '保存成功。',
      modifyError: '修改时出错。',
      exportSuccess: '数据导出成功！',
      noDataToExport: '没有可导出的数据。',
      exportError: '导出失败。请再试一次。',
      table: {
        date: '日期',
        totalCommission: '总返佣',
        totalTransactionAmount: '总交易金额',
        netHandlingFee: '净手续费',
        newInvitedPeopleCount: '新增邀请人数'
      }
    }
  }
}
